<!--上传文件-->
<template>
  <el-upload
    class="upload-demo"
    v-model="value"
    v-bind="$attrs"
    :id="'c' + formItemMeta.columnId"
    :name="'c' + formItemMeta.columnId"
    :accept="myAccept"
    :action="action"
    :on-preview="handlePreview"
    :on-remove="handleRemove"
    :on-change="myChange"
    :before-remove="beforeRemove"
    :on-exceed="handleExceed"
    :file-list="fileList"
  >
    <el-button type="primary">点击选择文件</el-button>
    <template #tip>
      <div class="el-upload__tip">
        文件大小不能超过 500KB
      </div>
    </template>
  </el-upload>
</template>

<script >
  import { defineComponent, reactive, computed } from 'vue'
  import { ElMessageBox, ElMessage } from 'element-plus'
  // import { ElUpload, ElButton, ElMessage, ElMessageBox } from 'element-plus'
  // 引入组件需要的属性、控制类
  import { itemProps, itemController } from '../map'

  export default defineComponent({
    name: 'nf-el-form-item-upload-file',
    components: {
      // ElUpload, ElButton
    },
    inheritAttrs: false,
    props: {
      ...itemProps, // 基础属性
      accept: {
        type: [String, Array],
        default: ''
      },
      action: {
        type: [String],
        default: 'https://aaa.com/posts/'
      },
      modelValue: [String]
    },
    emits: ['update:modelValue'],
    setup (props, context) {
      // console.log('props-text', props)
      const {
        value,
        run,
        clear,
        myinput
      } = itemController(props, context.emit)

      // 转换允许上传的类型
      const myAccept = computed(() => {
        if (Array.isArray(props.accept)) {
          return props.accept.join(',')
        } else {
          return props.accept
        }
      })

      const fileList = reactive([
        {
          name: 'food.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
        {
          name: 'food2.jpeg',
          url: 'https://fuss10.elemecdn.com/3/63/4e7f3a15429bfda99bce42a18cdd1jpeg.jpeg?imageMogr2/thumbnail/360x360/format/webp/quality/100',
        },
      ])

      // 重新选择文件
      const myChange = (file, fileList) => {
        console.log(file, fileList)
      }

      // 删除文件
      const handleRemove = (file, fileList) => {
        console.log(file, fileList)
      }
      const beforeRemove = (file, fileList) => {
        return ElMessageBox.confirm(`真的要删除 ${file.name} 文件吗？`)
      }
      
      const handlePreview = (file) => {
        console.log(file)
      }
      const handleExceed = (files, fileList) => {
        ElMessage.warning(
          `一次只能同时上传 3 个文件, 您选择的文件数量 ${files.length} 超出限制，
          ${files.length + fileList.length} `
        )
      }
      
      return {
        fileList,
        handleRemove,
        handlePreview,
        handleExceed,
        myChange,
        beforeRemove,
        value,
        myAccept, // 允许上传的文件类型
        run,
        clear,
        myinput
      }
    }
  })
</script>
